import { render, staticRenderFns } from "./MembershipSubscriptionProduct.vue?vue&type=template&id=04b98eda&scoped=true&"
import script from "./MembershipSubscriptionProduct.vue?vue&type=script&lang=js&"
export * from "./MembershipSubscriptionProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b98eda",
  null
  
)

export default component.exports